<template>
  <el-row type="flex" justify="center">
    <el-col :xs="24" :sm="20" :md="16" :lg="16" :xl="16">
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <PageTitle title="Calculadora de Frete" subtitle="Lista de serviços para a sua cotação" />
        </div>
        <CalculateResultList />
        <el-form ref="ruleForm" label-position="top">
          <el-form-item style="text-align: center" class="actionWrapper">
            <el-button type="primary" @click="$router.replace({ name: 'calculadora.frete' })" autofocus
              >Fazer nova cotação</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import PageTitle from "../../layout/PageTitle.vue";
import CalculateResultList from "./calculate/CalculateResultList.vue";

export default {
  name: "CalculateResultPage",
  components: {
    PageTitle,
    CalculateResultList,
  },
};
</script>
